/** Basketball match officiating — minimum hiring charges (KES). Keep in sync with backend match.py */
export const FIRST_OFFICIAL_MIN_HIRE_KES = 2000;
export const ADDITIONAL_OFFICIAL_MIN_HIRE_KES = 1000;
export const BASKETBALL_MAX_OFFICIATING_SLOTS = 3;

export const OFFICIATING_COUNT_OPTIONS = [
  {
    count: 1,
    label: "1 Official",
    summary: "Lead referee only — ideal for 3v3",
    icon: "fa-solid fa-user-shield",
    formats: ["3v3", "5v5"],
  },
  {
    count: 2,
    label: "2 Officials",
    summary: "Lead + second referee — standard 5v5",
    icon: "fa-solid fa-people-arrows",
    formats: ["5v5"],
  },
  {
    count: 3,
    label: "3 Officials",
    summary: "Two refs + table official (score & timer)",
    icon: "fa-solid fa-tablet-screen-button",
    formats: ["5v5"],
  },
];

export const OFFICIATING_SLOTS = [
  {
    slot: 1,
    label: "Lead Referee",
    role: "Primary on-court referee",
    icon: "fa-solid fa-user-shield",
  },
  {
    slot: 2,
    label: "Second Referee",
    role: "Secondary on-court referee",
    icon: "fa-solid fa-people-arrows",
  },
  {
    slot: 3,
    label: "Table Official",
    role: "Scorekeeper & game timer",
    icon: "fa-solid fa-tablet-screen-button",
  },
];

export function officiatingSlotMinimumKes(slotNumber) {
  if (slotNumber <= 0) return 0;
  if (slotNumber === 1) return FIRST_OFFICIAL_MIN_HIRE_KES;
  return ADDITIONAL_OFFICIAL_MIN_HIRE_KES;
}

export function officiatingMinimumCostKes(slotsRequested) {
  if (!slotsRequested || slotsRequested <= 0) return 0;
  const capped = Math.min(Number(slotsRequested), BASKETBALL_MAX_OFFICIATING_SLOTS);
  let total = 0;
  for (let slot = 1; slot <= capped; slot += 1) {
    total += officiatingSlotMinimumKes(slot);
  }
  return total;
}

export function formatKes(amount) {
  return `KSh ${Number(amount).toLocaleString("en-KE")}`;
}

export function activeOfficiatingSlots(count) {
  if (!count || count <= 0) return [];
  return OFFICIATING_SLOTS.slice(0, Math.min(count, OFFICIATING_SLOTS.length));
}

export function defaultOfficiatingCountForFormat(matchFormat) {
  if (matchFormat === "3v3") return 1;
  if (matchFormat === "5v5") return 2;
  return 2;
}

export function officiatingCountOptionsForFormat(matchFormat) {
  if (matchFormat === "3v3") {
    return OFFICIATING_COUNT_OPTIONS.filter((opt) => opt.count === 1);
  }
  return OFFICIATING_COUNT_OPTIONS;
}
